import script from "./CustomSelectboxMulti.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSelectboxMulti.vue?vue&type=script&setup=true&lang=js"

import "./CustomSelectboxMulti.vue?vue&type=style&index=0&id=54106b11&lang=css"

const __exports__ = script;

export default __exports__